import IntegrationTestingLayout from "features/internal/integration-testing/IntegrationTestingLayout";
import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";

export const integrationTestingRoutes: RouteObject = {
  id: "integrationTesting",
  path: "integration-testing",
  element: <IntegrationTestingLayout />,
  handle: {
    showSidebar: true,
  },
  children: [
    {
      id: "integrationTestingIndex",
      path: "*",
      handle: {
        showSidebar: true,
      },
      lazy: async () => {
        const { InternalIntegrationTestingPage } = await import(
          "features/internal/integration-testing/InternalIntegrationTestingPage"
        );
        return { Component: InternalIntegrationTestingPage };
      },
      children: [
        {
          id: "activity",
          path: "",
          handle: {
            showSidebar: true,
            title: i18n.t("common:activity"),
          },
          lazy: async () => {
            const { InternalIntegrationTestingActivityTab } = await import(
              "features/internal/integration-testing/tabs/InternalIntegrationTestingActivityTab"
            );
            return { Component: InternalIntegrationTestingActivityTab };
          },
        },
        {
          id: "configurations",
          path: "configurations",
          handle: {
            showSidebar: true,
            title: i18n.t("common:configuration"),
          },
          lazy: async () => {
            const { InternalIntegrationTestingConfigurationTab } = await import(
              "features/internal/integration-testing/tabs/InternalIntegrationTestingConfigurationTab"
            );
            return { Component: InternalIntegrationTestingConfigurationTab };
          },
        },
      ],
    },
    {
      id: "integrationTestingReport",
      path: ":integrationTestingReportId/report",
      handle: {
        showSidebar: true,
      },
      lazy: async () => {
        const { InternalIntegrationTestingReportPage } = await import(
          "features/internal/integration-testing/InternalIntegrationTestingReportPage"
        );
        return { Component: InternalIntegrationTestingReportPage };
      },
    },
    {
      id: "integrationTestingReportUpdate",
      path: ":integrationTestingReportId/update",
      handle: {
        showSidebar: true,
      },
      lazy: async () => {
        const { InternalIntegrationTestingUpdatePage } = await import(
          "features/internal/integration-testing/InternalIntegrationTestingUpdatePage"
        );
        return { Component: InternalIntegrationTestingUpdatePage };
      },
    },
    {
      id: "integrationTestingIndividualReport",
      path: ":integrationTestingReportId/report/:integrationIndividualTestingReportId/individual-report",
      handle: {
        showSidebar: true,
      },
      lazy: async () => {
        const { InternalIntegrationTestingIndividualReportPage } = await import(
          "features/internal/integration-testing/InternalIntegrationTestingIndividualReportPage"
        );
        return { Component: InternalIntegrationTestingIndividualReportPage };
      },
    },
    {
      id: "configuration",
      path: "configurations/:integrationTestingConfigurationId/",
      handle: {
        showSidebar: true,
        title: i18n.t("common:configuration"),
      },
      lazy: async () => {
        const { InternalIntegrationTestingConfigurationPage } = await import(
          "features/internal/integration-testing/tabs/InternalIntegrationTestingConfigurationPage"
        );
        return { Component: InternalIntegrationTestingConfigurationPage };
      },
    },
  ],
};
